var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_99_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5376 20.0006L39.2671 4.27106C40.2443 3.29463 40.2443 1.71034 39.2671 0.733919C38.2898 -0.243338 36.7072 -0.243338 35.7299 0.733919L20.0004 16.4634L4.27008 0.733919C3.29282 -0.243338 1.7102 -0.243338 0.732943 0.733919C-0.244314 1.71034 -0.244314 3.29463 0.732943 4.27106L16.4633 20.0006L0.732943 35.7301C-0.244314 36.7065 -0.244314 38.2908 0.732943 39.2672C1.22157 39.755 1.86196 39.9993 2.50151 39.9993C3.14106 39.9993 3.78145 39.755 4.27008 39.2664L20.0004 23.5369L35.7299 39.2664C36.2185 39.755 36.8589 39.9993 37.4985 39.9993C38.138 39.9993 38.7784 39.755 39.2671 39.2664C40.2443 38.2899 40.2443 36.7057 39.2671 35.7292L23.5376 20.0006Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_99_669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.419383317b06e4a1cd8ba3b662977e4a.svg";
export { ForwardRef as ReactComponent };